<template>
    <v-container class="pa-4">
        <v-data-table
            :headers="headers"
            :items="list"
            class="elevation-5"
            :loading="loading"
            :server-items-length="total"
            :page.sync="page"
            @page-count="pageCount = $event"
            @update:page="sync"
            hide-default-footer
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="clickCreate">新增</v-btn>
                    <confirm-dialog
                        ref="confirmDialog"
                        :handleSubmit="handleDelete"
                    />
                </v-toolbar>
                <v-row>
                    <v-col>
                        <v-select
                            v-model="filter.type"
                            :items="reportTypeOptions"
                            label="類型"
                            solo
                            hide-details
                            @change="changeFilter"
                        ></v-select>
                    </v-col>
                    <v-col>
                        <search
                            v-model="query"
                            @change="changeFilter"
                            label="年份"
                        />
                    </v-col>
                </v-row>
            </template>
            <template v-slot:footer>
                <v-pagination
                    v-if="pageCount > 0"
                    class="py-2"
                    v-model="page"
                    :length="pageCount"
                    :total-visible="7"
                ></v-pagination>
            </template>
            <template v-slot:[`item.title`]="{ item }">
                {{ item.title["zhTw"] }}
            </template>
            <template v-slot:[`item.online`]="{ item }">
                {{ item.online ? "開啟" : "關閉" }}
            </template>
            <template v-slot:[`item.updateAt`]="{ item }">
                {{ item.updateAt | moment("YYYY/MM/DD") }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="clickUpdate(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="showDeleteDialog(item)">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import OperationMixin from '@/views/mixins/OperationMixin';
import ReportTypeMixin from '@/views/mixins/ReportTypeMixin';
import Search from '@/components/Search.vue';

export default {
    mixins: [OperationMixin, ReportTypeMixin],
    components: {
        ConfirmDialog,
        Search,
    },
    data: () => ({
        headers: [
            { text: '年份', value: 'year' },
            { text: '標題', value: 'title' },
            { text: '更新時間', value: 'updateAt' },
            { text: '編輯者', value: 'modifiedBy' },
            { text: '狀態', value: 'online' },
            { text: '操作', value: 'actions', sortable: false },
        ],
    }),
    computed: {
        ...mapState('report', ['list', 'total']),
        title() {
            return '財務報告';
        },
        fields() {
            return [{
                name: '類型', type: 'select', key: 'type', required: true, items: this.reportTypeOptions,
            }, {
                name: '年份',
                type: 'number',
                key: 'year',
                required: true,
                default: moment().year(),
            }, {
                name: '季度',
                type: 'select',
                key: 'quarter',
                required: true,
                condition: { ref: 'type', value: 'quarter' },
                items: [
                    { value: '1st', text: '1' },
                    { value: '2nd', text: '2' },
                    { value: '3rd', text: '3' },
                    { value: '4th', text: '4' },
                ],
            }, {
                name: '月份',
                type: 'number',
                key: 'month',
                required: true,
                condition: { ref: 'type', value: 'month' },
                min: 1,
                max: 12,
                default: 1,
            }, {
                name: '標題', type: 'text-i18n', key: 'title', required: true,
            }, {
                name: '附件', type: 'file', key: 'file', required: true, accept: 'application/pdf',
            }, {
                name: '狀態',
                type: 'radio',
                key: 'online',
                items: [
                    { text: '開啟', value: true },
                    { text: '關閉', value: false },
                ],
                required: true,
            }];
        },
    },
    methods: {
        ...mapActions('report', ['fetch', 'delete']),
        clickCreate() {
            this.$router.push({
                name: 'Form',
                params: {
                    name: this.title,
                    resource: 'report',
                    fields: this.fields,
                },
            });
        },
        clickUpdate(data) {
            this.$router.push({
                name: 'Form',
                params: {
                    name: this.title,
                    resource: 'report',
                    fields: this.fields,
                    payload: data,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.row {
    margin: 12px !important;
}
</style>
